import { CheckCircle2, Info, XCircle } from "lucide-react";
import { Tooltip } from "react-tooltip";
import Table from "../../common/components/Table";
import ApiValidate from "../../common/components/ApiValidate";

function PagePermissions({
  permissions,
  isOwner,
  pagePermissions,
  isGettingPagePermisions,
  isErrorOnPagePermission,
}) {
  return (
    <div className="text-gray-700">
      <div className="flex space-x-4">
        <div className=" text-lg">Your pages and permissions</div>
        <div id="permissions-info">
          <Info />
        </div>

        <Tooltip anchorSelect="#permissions-info">
          <DisplayPermissions permissions={permissions} />
        </Tooltip>
      </div>

      <ApiValidate
        isLoading={isGettingPagePermisions}
        isError={isErrorOnPagePermission}
      >
        {isOwner ? (
          <div className="text-gray-500 mt-4">
            You are an owner for this organization
          </div>
        ) : (
          <DisplayPagePermissions
            permissions={permissions}
            pagePermissions={pagePermissions}
          />
        )}
      </ApiValidate>
    </div>
  );
}

export default PagePermissions;

export function DisplayPermissions({ permissions }) {
  return (
    <div className="max-w-[200px]">
      {permissions?.map((permission, i) => {
        const { label, description } = permission;
        return (
          <div key={i} className="my-4">
            <div className="font-bold mb-1">{label}</div>
            <div>{description}</div>
          </div>
        );
      })}
    </div>
  );
}

function getPagePermissionsColumn(permissions = []) {
  const columns = [
    {
      name: "Page",
      renderComp: (data) => data?._id?.name,
    },
  ];

  permissions.forEach((permission) => {
    const { label, _id } = permission;

    columns.push({
      name: label,
      renderComp: (data) => {
        const isHavingPermission =
          data.permissions?.length && data.permissions.includes(_id);

        return isHavingPermission ? (
          <CheckCircle2 className="text-green-700" />
        ) : (
          <XCircle className="text-gray-500" />
        );
      },
    });
  });

  return columns;
}

function DisplayPagePermissions({ permissions = [], pagePermissions = [] }) {
  const columns = getPagePermissionsColumn(permissions);

  return (
    <div>
      <Table data={pagePermissions} columns={columns} />
    </div>
  );
}
